import { createAction, props } from '@ngrx/store';

export const NavigationToggleCollapsed = createAction('navigation-toggle-collapsed', props<{ isCollapsed: boolean }>());
